import { DissectedError } from '../errors/DissectedError'
import { HandledApplicationError } from '../errors/HandledApplicationError'

/**
 * Maps a dissected error to a HandledApplicationError
 *
 * @param formId
 * @param error
 * @param validationErrorPathMap -- optional key-value object. The key should be the validation property name you expect
 *                                  from the api, and the value should be your input name where you want to show the validation.
 *
 * @example
 * throw getHandledErrorWithValidationErrors(SERVICE_POINT_FORM_ID, error, {
 *        'PickupAddress.PostalCode': ServicePointFieldName.POSTAL_CODE,
 *        'PickupAddress.Number': ServicePointFieldName.HOUSE_NUMBER,
 *    })
 *
 * @todo refactor validationError mapping to separate helper when performance in client actions becomes a problem -- serialization
 *      and deserialization is only necessary when using a server action. For now, we keep the workflow the same for client and
 *      server actions, but when the amount of validation errors in a response gets too big, we may have to refactor
 */
export const getHandledErrorWithValidationErrors = (
    formId: string,
    error: DissectedError,
    validationErrorPathMap?: {
        [key: string]: string
    },
) =>
    new HandledApplicationError(error.message, {
        formId,
        //@ts-ignore
        validationErrors:
            error.apiResponse?.validationErrors?.map((validationError) => {
                const message = validationError.errorCode ?? ''
                if (
                    validationError.propertyName &&
                    validationErrorPathMap &&
                    validationError.propertyName in validationErrorPathMap
                )
                    return {
                        path: validationErrorPathMap[validationError.propertyName],
                        message,
                    }

                return {
                    path: validationError.propertyName,
                    message,
                }
            }) ?? [],
    })
